module.exports = __webpack_public_path__ + "img/__icon_IZOTERMA.13cf8600.svg";